module.exports = __webpack_public_path__ + "static/media/section3div3Main2ymhx.a256074b.gif";